




import mixins from 'vue-typed-mixins';
import {
  DashboardTile,
  TileSubmissionStatusOptions,
} from '@/utils/DashboardUtils';

export default mixins().extend({
  props: {
    value: {
      type: Object as () => TileSubmissionStatusOptions,
    },
  },

  beforeMount() {
    this.$emit('input', {});
  },
});
